import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from 'react';
import { translate } from '../i18n';
const LocaleContext = createContext(undefined);
export const LocaleProvider = ({ children }) => {
    const [locale, setLocaleState] = useState('ja');
    const setLocale = useCallback((l) => {
        setLocaleState(l);
        document.documentElement.lang = l;
    }, []);
    const t = useCallback((key) => translate(key, locale), [locale]);
    return (_jsx(LocaleContext.Provider, { value: { locale, setLocale, t }, children: children }));
};
export function useLocale() {
    const ctx = useContext(LocaleContext);
    if (!ctx)
        throw new Error('useLocale must be used within LocaleProvider');
    return ctx;
}
